import {
  type QueryKey,
  type UseQueryOptions as UseQueryReactOptions,
  useQuery as useQueryReact,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';

type UseQueryOptions<
  TQueryFunctionData,
  TError extends AxiosError = AxiosError,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
> = UseQueryReactOptions<TQueryFunctionData, TError, TData, TQueryKey>;

export const useQuery = <
  TQueryFunctionData,
  TError extends AxiosError = AxiosError,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFunctionData, TError, TData, TQueryKey>,
) =>
  useQueryReact<TQueryFunctionData, TError, TData, TQueryKey>({
    gcTime: 1 * 24 * 60 * 60 * 1000, // 1 Day
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 Minutes
    throwOnError: true,
    ...options,
  });
